
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.917 6.25V.75h7.333v5.5H9.917zM.75 9.917V.75h7.333v9.167H.75zm9.167 7.333V8.083h7.333v9.167H9.917zm-9.167 0v-5.5h7.333v5.5H.75z"}})])
          )
        }
      }
    